import type { BuildConfig } from './build.types';
import { boot } from './boot';

declare const __EKKO_CORE__: BuildConfig;

boot(__EKKO_CORE__);
